<template>
	<div class="login-wrap">
        <loginLayout>
            <p class="ft36 bold cfff mb30">溯源码管理系统</p>
            <p class="ft24 cfff mb30">您好！欢迎登录</p>
            <el-form class="login-form" :model="loginForm" ref="loginForm">
                <el-form-item prop="username" :rules="{required: true, message: '请输入您的账号'}">
                    <el-input 
                        class="login-input" 
                        :class="{'error-input': loginForm.errors.hasOwnProperty('username') && loginForm.errors.username.length > 0 }"
                        placeholder="请输入您的账号" 
                        v-model="loginForm.username" 
                        prefix-icon="iconfont icon-yonghu1" 
                        @blur="judgeNeedCode"></el-input>
                </el-form-item>
                <el-form-item prop="userpwd" :rules="{required: true, message: '请输入您的密码'}">
                    <el-input 
                        class="login-input" 
                        :class="{'error-input': loginForm.errors.hasOwnProperty('userpwd') && loginForm.errors.userpwd.length > 0 }"
                        placeholder="请输入您的密码" 
                        type="password" 
                        prefix-icon="iconfont icon-mima1" 
                        v-model="loginForm.userpwd" 
                        @keyup.enter.native="login"></el-input>
                </el-form-item>
                <el-form-item prop="ding_code" :rules="{required:true,message:'请输入钉钉验证码'}" v-if="!loginForm.hasDingCode && loginForm.loginType == 'emp'">
                    <div class="flex flex-ac flex-pj">
                        <el-input 
                            class="login-input code-input" 
                            :class="{'error-input': loginForm.errors.hasOwnProperty('ding_code') && loginForm.errors.ding_code.length > 0 }"
                            placeholder="钉钉验证码" 
                            v-model="loginForm.ding_code" 
                            prefix-icon="iconfont icon-zhengque"></el-input>
                        <span class="code-wrap" @click="getDingCode">
                            <span class="code-btn" :class="{'disable-code-btn': loginForm.username === ''}" v-if="!loginForm.showTime" :disabled="loginForm.username === ''" title="请先输入用户名">获取验证码</span>
                            <span class="code-btn time-span" v-else>{{ loginForm.time }}s</span>
                        </span>
                    </div>
                </el-form-item>
                <div class="flex flex-ac flex-pj ft14 cfff mb20">
                    <el-checkbox class="remember-pwd-check" v-model="loginForm.savePwd">记住密码</el-checkbox>
                    <span class="cursor ft14" @click="toReset" v-if="loginForm.loginType == 'emp'">忘记密码</span>
                </div>
                <div class="login-btn mb30" @click="submitLogin">登录</div>
                <div class="dingding-login rela" @click="getDingQRCodeUrl" v-if="loginForm.loginType == 'emp'">
                    <img class="dingding-logo dib v-middle" src="./images/dingding.png">
                    <span class="dib v-middle">钉钉一键登录 | 扫码登录</span>
                </div>
            </el-form>
            <!-- 商家版/内部版切换入口 -->
            <div class="login-type-change ft13 abs">
                <span class="login-type cursor" :class="{'active': loginForm.loginType == 'business'}" @click="changeLoginType('business')">商家版</span>
                <span class="ly-div ml5 mr5">/</span>
                <span class="login-type cursor" :class="{'active': loginForm.loginType == 'emp'}"  @click="changeLoginType('emp')">内部版</span>
            </div>
        </loginLayout>
	</div>
</template>

<script>
	import jwtdecode from 'jwt-decode'
	import {commonApi} from '@/api/common'
    import loginLayout from './components/loginLayout.vue'
	export default {
		data() {
			return {
				rules: {
					orgId: [{
						required: true,
						message: '请选择使用组织',
						trigger: 'blur'
					}],
					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					userpwd: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}]
				},
				loginForm: {
                    loginType: 'business', // business：商家；emp：员工
					username: '',
					userpwd: '',
					orgId: 100,
					ding_code:'',
					hasDingCode:true,//是否有钉钉验证码
					showTime:false,//是否显示计时器
					time:60,
					timeObj:null,//计时器
                    savePwd: false,
                    errors: {
                        username: '',
                        userpwd: '',
                        ding_code: ''
                    } // 用于存储表单验证的错误信息  
				}
			}
		},
        components: {
            loginLayout
        },
		beforeRouteEnter(to,form,next) {
			next(vm=>{
				vm.clearData()
			})
		},
        created() {
            const loginType = localStorage.getItem(this.$EpetJs.Const.LoginTypeName) || 'business'
            this.loginForm.loginType = loginType

            let loginAccount = localStorage.getItem(this.$EpetJs.Const.SavePwdAccountName) ? JSON.parse(localStorage.getItem(this.$EpetJs.Const.SavePwdAccountName)) : ''
            let savePwd = localStorage.getItem(this.$EpetJs.Const.SavePwdName) ? JSON.parse(localStorage.getItem(this.$EpetJs.Const.SavePwdName)) : false
            this.loginForm.savePwd = savePwd
            if(loginAccount) {
                this.loginForm.username = loginAccount.name
                this.loginForm.userpwd = loginAccount.password
            }
        },
		methods: {
			//清除相关数据
			clearData() {
				this.loginForm.showTime = false
				this.loginForm.time = 60
			},
			//判断是否需要钉钉口令
			judgeNeedCode() {
                if(this.loginForm.loginType !== 'emp') {
                    return false
                }
				this.loginForm.username = this.loginForm.username.trim()
				if(this.loginForm.username === '') {
					return false;
				}
				this.$EpetJs.Common.ajax('get',commonApi.judgeNeedCodeUrl,{
					user_name: this.loginForm.username
				}).then(res => {
				if(res) {
					this.loginForm.hasDingCode = res.data.data;
				}
				})
			},
			//获取钉钉验证码
			getDingCode() {
				this.loginForm.time = 60
				this.$EpetJs.Common.ajax('get',commonApi.getDingCodeUrl,{
					user_name:this.loginForm.username
				}).then(res => {
					if(res) {
						this.loginForm.showTime = true
						this.loginForm.timeObj = setInterval(()=>{
							this.loginForm.time--
							if(this.loginForm.time == 0) {
								this.loginForm.showTime = false
								this.clearTime()
							}
						},1000)
					}
				})
			},
			//清除定时器
			clearTime() {
				clearInterval(this.loginForm.timeObj)
			},
            // 切换登录类型
            changeLoginType(type) {
                this.loginForm.loginType = type
                localStorage.setItem(this.$EpetJs.Const.LoginTypeName, type)
            },
			//登录
			submitLogin() {
				this.$refs['loginForm'].validate((valid) => {
					if (valid) {
						const pam = {
							name: this.loginForm.username.trim(),
							password: this.loginForm.userpwd,
							ding_code:this.loginForm.ding_code,
							ac_type: 2,
							org_id: this.loginForm.orgId
						}
						//如果接入了单点登录，需要传平台名称
						if (this.$store.state.ssoLogin) {
							pam.platform = this.$store.state.platformName
						}
                        // 处理记住密码
                        if(this.loginForm.savePwd) {
                            let loginAccount = localStorage.getItem(this.$EpetJs.Const.SavePwdAccountName) ? JSON.parse(localStorage.getItem(this.$EpetJs.Const.SavePwdAccountName)) : {}
                            loginAccount = {
                                name: this.loginForm.username.trim(),
                                password: this.loginForm.userpwd
                            }
                            localStorage.setItem(this.$EpetJs.Const.SavePwdAccountName, JSON.stringify(loginAccount))
                            localStorage.setItem(this.$EpetJs.Const.SavePwdName, true)
                        }else {
                            localStorage.setItem(this.$EpetJs.Const.SavePwdAccountName, null)
                            localStorage.setItem(this.$EpetJs.Const.SavePwdName, false)
                        }

                        // 商家登录
                        if(this.loginForm.loginType == 'business') {
                            this.$EpetJs.Common.ajax('post', commonApi.businessLoginUrl, pam).then(res => {
                                if(res) {
                                    this.loginSuccess(res.data)
                                }
                            })
                        // 员工登录
                        }else {
                            this.$store.dispatch('getRoles', pam).then((res) => { //获取用户权限
                                if (res.status_code != 200) {
                                    //提示错误信息
                                    this.$message({
                                        message: res.message,
                                        type: 'error'
                                    });
                                    //钉钉口令失效
                                    if(res.status_code == '103106') {
                                        this.loginForm.hasDingCode = false
                                    }
                                    return
                                }
                                // 密码通过，存储token等信息，跳转首页
                                if(res.data.password_is_need_change.pass) {
                                    this.loginSuccess(res)
                                }else {
                                    this.$router.push(
                                        {
                                            name:'reset_pwd', 
                                            params:{
                                                name: this.loginForm.username,
                                                password: this.loginForm.userpwd,
                                                referer: this.$route.query.referer?this.$route.query.referer:'',
                                                password_is_need_change:res.data.password_is_need_change 
                                            }
                                        })
                                }
                            }).catch(_=>{
                                
                            })
                        }
					}else {
                        this.loginForm.errors.username = this.$refs['loginForm'].fields.find(v => { return v.prop == 'username' }) 
                            && this.$refs['loginForm'].fields.find(v => { return v.prop == 'username' }).validateState
                            && this.$refs['loginForm'].fields.find(v => { return v.prop == 'username' }).validateState == 'error'
                            ?  this.$refs['loginForm'].fields.find(v => { return v.prop == 'username' }).validateMessage
                            : ''
                        this.loginForm.errors.userpwd = this.$refs['loginForm'].fields.find(v => { return v.prop == 'userpwd' }) 
                            && this.$refs['loginForm'].fields.find(v => { return v.prop == 'userpwd' }).validateState
                            && this.$refs['loginForm'].fields.find(v => { return v.prop == 'userpwd' }).validateState == 'error'
                            ?  this.$refs['loginForm'].fields.find(v => { return v.prop == 'userpwd' }).validateMessage
                            : ''
                        this.loginForm.errors.ding_code = this.$refs['loginForm'].fields.find(v => { return v.prop == 'ding_code' }) 
                            && this.$refs['loginForm'].fields.find(v => { return v.prop == 'ding_code' }).validateState
                            && this.$refs['loginForm'].fields.find(v => { return v.prop == 'ding_code' }).validateState == 'error'
                            ?  this.$refs['loginForm'].fields.find(v => { return v.prop == 'ding_code' }).validateMessage
                            : ''
                    }
				})
			},
            loginSuccess(res) {
                //存储用户相关信息到store
                var userId = jwtdecode(res.data.token).user.uid
                var acId = jwtdecode(res.data.token).user.acId
                var expire = jwtdecode(res.data.token).exp
                this.$store.commit('changeLoginState', {
                    isLogin: true
                })
                this.$store.commit('saveUser', {
                    userName: this.loginForm.username,
                    userId: userId,
                    acId: acId
                })
                this.$store.commit('saveToken', {
                    token: res.data.token,
                    refreshToken: res.data.refresh_token,
                    expire: expire
                })
                //如果有跳转链接，则登录成功之后跳转
                if (this.$route.query.referer) {
                    this.$router.replace(this.$route.query.referer)
                } else {
                    this.$router.replace('/')
                }
            },
			//跳转重置密码页面
			toReset() {
				this.$router.push('/reset')
			},
			// 获取钉钉二维码页面
			getDingQRCodeUrl() {
				this.$EpetJs.Common.ajax('get',commonApi.getDingQRCodeUrl,{
					app_name: this.$store.state.platformName
				}).then(res => {
					if(res) {
                        if(res.data.data  && res.data.data.length > 0 && res.data.data[0].ding_login_url) {
                            let ding_login_url = res.data.data[0].ding_login_url
                            const referer = this.$route.query.referer ? this.$route.query.referer : ''
                            if(referer) {
                                let preUrl = ding_login_url.split('&response_type')[0].split('redirect_uri=')[0]
                                let nextUrl = ding_login_url.split('&response_type')[1]
                                let url = ding_login_url.split('&response_type')[0].split('redirect_uri=')[1]
                                let redirect_uri = `${window.decodeURIComponent(url)}&referer=${referer}`
                                ding_login_url = `${preUrl}redirect_uri=${window.encodeURIComponent(redirect_uri)}&response_type${nextUrl}`
                            }
							window.location = ding_login_url
						}
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.login-wrap {
		min-width: 1000px;
		position: relative;
		width: 100%;
		height: 100%;
        background: #1760E6;
	}

	.login-content {
		position: absolute;
		left: calc(50% - 190px);
		top: calc(50% - 270px);
		width: 380px;
		height: 160px;
	}

	.login-content {
        width: 365px;
        margin-left: 16.22%;
        .login-form {
            /deep/.el-form-item__error {
                display: none;
            }
        }
        .login-input {
            /deep/.el-input__inner {
                color: #ffffff;
                font-size: 14px;
                height: 55px;
                line-height: 55px;
                padding-left: 60px;
                background: rgba(255,255,255,0.08);
                box-shadow: inset 0px 5px 15px 0px rgba(34,84,204,0.4);
                border-radius: 30px;
                border: 1px solid rgba(253,253,253,0.8);
                &::-webkit-input-placeholder {
                    color: #B9D1F8;
                }
                &:focus {
                    border: 2px solid rgba(253,253,253,1);
                }
            }
            /deep/.el-input__prefix {
                padding-left: 18px;
                margin: 2px 12px 0 0;
                .el-input__icon {
                    font-size: 25px;
                    color: #B9D1F8;
                }
            }
            &.error-input {
                /deep/.el-input__inner {
                    &::-webkit-input-placeholder {
                        color: #ffffff;
                    }
                }
            }
        }
        .code-input {
            width: 210px;
        }
        .code-wrap {
            display: inline-block;
            width: 130px;
            height: 55px;
            line-height: 55px;
            text-align: center;
            background: rgba(255, 255, 255, .3);
            color: #EBFAFF;
            cursor: pointer;
            border-radius: 30px;
            border: 1px solid rgba(253,253,253,0.8);
        }
        .disable-code-btn {
            cursor: not-allowed;
        }
        .remember-pwd-check {
            color: #ffffff;
            &.is-checked {
                /deep/.el-checkbox__inner {
                    background-color: #6D99ED !important;
                    border-color: #DCDFE6 !important;
                    &::after {
                        width: 5px;
                        height: 8px;
                        top: 2px;
                        border-width: 2px;
                    }
                }
            }
            /deep/.el-checkbox__inner {
                width: 20px;
                height: 20px;
                border-radius: 10px;
                background: #6D99ED;
                &::after {
                    top: 3px;
                    left: 6px;
                }
                &:hover {
                    border-color: #DCDFE6;
                }
            }
            /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
                color: #ffffff;
            }
        }
        .login-btn {
            width: 100%;
            height: 55px;
            border-radius: 30px;
            line-height: 55px;
            text-align: center;
            cursor: pointer;
            color: #ffffff;
            font-size: 20px;
            background: linear-gradient(90deg, #00C0FA, #537DFB);
            box-shadow: 0px 15px 25px 0px rgba(1,52,215,0.3);
            &:hover {
                background: linear-gradient(90deg, #68E0CF, #209CFF);
            }
        }
        .dingding-login {
            height: 55px;
            border-radius: 30px;
            line-height: 48px;
            text-align: center;
            cursor: pointer;
            font-size: 16px;
            color: #ffffff;
            border: 1px dashed #ffffff;
            &:hover {
                background-color: rgba(75, 197, 226, .3);
            }
            .dingding-logo {
                width: 30px;
                height: 30px;
            }
        }
        .login-type-change {
            bottom: 50px;
            left: 0;
            width: 100%;
            text-align: center;
            .login-type {
                color: #d7d7d7;
                &.active {
                    color: #ffffff;
                    font-weight: bold;
                }
            }
            .ly-div {
                color: #d7d7d7;
            }
        }
    }
</style>
